import Icon from "@atlaskit/icon";
import type { CustomGlyphProps } from "@atlaskit/icon/types";
import { R300 } from "@atlaskit/theme/colors";

const PriorityBlocker24Glyph = (props: CustomGlyphProps) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid={props["data-testid"]}
        className={props.className}
    >
        <path
            d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM7 11L6.88338 11.0067C6.38604 11.0645 6 11.4872 6 12C6 12.5523 6.44772 13 7 13H17L17.1166 12.9933C17.614 12.9355 18 12.5128 18 12C18 11.4477 17.5523 11 17 11H7Z"
            fill={R300}
        />
    </svg>
);

export const PriorityBlocker24Icon = ({ label }: { label: string }) => {
    return <Icon glyph={PriorityBlocker24Glyph} label={label} />;
};
